import { useEffect } from 'react';
import Ai2Layout from '../components/Ai2/Ai2Layout';

const CALENDLY_URL = 'https://calendly.com/vironai2/ai2-class';

function Ai2CourseSchedule() {
    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.body.appendChild(script);
        return () => {
            link.remove();
            script.remove();
        };
    }, []);

    return (
        <Ai2Layout>
            <div className='container'>
                <div className="row">
                    <div className='col'>
                        <div style={{ paddingTop: '2rem' }} className="text-center">
                            <img src='https://viron.network/assets/img/Ai2Logo.png' alt="Viron Logo" className="img-logo-center" />
                            <h3 className='mt-0 mb-4'>Course Calendar</h3>
                        </div>
                        <div className="calendly-inline-widget"
                            data-url={CALENDLY_URL}
                            style={{ minWidth: '320px', height: '700px' }}
                            title="Schedule an Ai2 class" />
                    </div>
                </div>
            </div>
        </Ai2Layout >
    );
}
export default Ai2CourseSchedule;

